import { anonymousRequest, authRequest, ACCESS_TOKEN } from './auth';

const obtainPaymentIntent = (data) => {
    return anonymousRequest.post('/payments/', data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

const deletePaymentMethod = async (paymentMethodId) => {
    return authRequest.delete(`/payment-methods/${paymentMethodId}`)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

const checkPromoCode = (data) => {
    if (window.localStorage.getItem(ACCESS_TOKEN) === null) {
        return anonymousRequest.get(`/promo-codes/${data.promoCode}/`)
        .then((response) => Promise.resolve(response.data))
        .catch((error) => Promise.reject(error));
    } else {
        return authRequest.get(`/promo-codes/${data.promoCode}/`)
        .then((response) => Promise.resolve(response.data))
        .catch((error) => Promise.reject(error));
    }
}

export { obtainPaymentIntent, deletePaymentMethod, checkPromoCode };